import React, { FC, forwardRef } from 'react';
import classNames from 'classnames';
import { WindowWidthContext } from '@minecraft.utils';
import { useMergedResponsiveProps } from '../helpers';
import { FlexProps } from '../types';
import { FlexBase } from './FlexBase';

export const FlexCol = forwardRef<HTMLDivElement, Omit<FlexProps & { children?: React.ReactNode }, 'direction'>>(
  ({ smProps, mdProps, lgProps, xlProps, ...props }, ref) => {
    const allProps = useMergedResponsiveProps({ props, smProps, mdProps, lgProps, xlProps });
    return <FlexBase {...allProps} direction="column" ref={ref} />;
  }
);
FlexCol.displayName = 'FlexCol';

export const FlexRow = forwardRef<HTMLDivElement, Omit<FlexProps & { children?: React.ReactNode }, 'direction'>>(
  ({ smProps, mdProps, lgProps, xlProps, ...props }, ref) => {
    const allProps = useMergedResponsiveProps({ props, smProps, mdProps, lgProps, xlProps });
    return <FlexBase {...allProps} direction="row" ref={ref} />;
  }
);
FlexRow.displayName = 'FlexRow';

export const FlexGrow: FC = ({ children }) => <div style={{ flex: 1 }}>{children}</div>;

export const FlexDynamic = forwardRef<HTMLDivElement, FlexProps & { children?: React.ReactNode }>(
  ({ children, smProps, mdProps, lgProps, xlProps, ...props }, ref) => {
    const allProps = useMergedResponsiveProps({ props, smProps, mdProps, lgProps, xlProps });

    return (
      <FlexBase {...allProps} ref={ref}>
        {children}
      </FlexBase>
    );
  }
);
FlexDynamic.displayName = 'FlexDynamic';

/**
 * @deprecated Use <FlexDynamic direction="column" mdProps={{ direction: 'row' }}> instead
 */
export const FlexSmColMdRow: FC<Omit<FlexProps, 'direction'>> = (props) => {
  const { lessMd } = WindowWidthContext.useWidthData();

  return <FlexBase {...props} direction={lessMd ? 'column' : 'row'} />;
};

export const ScrollableFlexCol = forwardRef<
  HTMLDivElement,
  Omit<FlexProps & { children?: React.ReactNode }, 'direction'>
>(({ className, ...props }, ref) => (
  <FlexCol {...props} ref={ref} isScrollbar className={classNames('cn_overflow-y-auto', className)} />
));
ScrollableFlexCol.displayName = 'ScrollableFlexCol';
